import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import Logo from "../../../assets/images/logo.png";
import Check from "../../../assets/images/check.png";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import '../login.css'

var count: number = 300;

function ForgotSuccess() {
  
  return (
    <>
      <Container fluid style={{ height: "auto" }}>
        <Row sm={3}>
          <Col></Col>
          <Col className="bg-white tb-mar-mob0-desk48 mx-auto loginshadow" xxl={3} xs={10}>
            <div className="my-5 lr-mar-mob4-desk24 py-5">
              <Image
                className="mx-auto d-block"
                style={styles.limg}
                src={Logo}
              />
              <div className="mt-2 mb-3" style={styles.head}>
                Ethics and governance portal
              </div>
              <Image
                className="mx-auto d-block mt-4 mb-2"
                style={styles.img2}
                src={Check}
              />
              <Row>
                <div className="pt-1" style={styles.text1}>
                  Password changes successfully.
                </div>
              </Row>
              {/* <div className="mt-2 mb-3" style={styles.text2}>
                Email with instructions to reset your password was sent to
                gauri@mahindra.com
              </div> */}
              <Button
                href="/login"
                style={styles.btn1}
                variant="danger"
                type="submit"
              >
                <label className="pt-2">Back to Login</label>
              </Button>
              <br />
              {/* <br />
              <Row className="justify-content-md-center">
                <div className="mb-5" style={styles.text4}>
                  Resend email in &nbsp;
                  <div className="mb-5 d-inline" style={styles.text5}>
                    {min >= 0 ? min + ":" + sec : "00:00"}
                  </div>
                </div>
              </Row> */}
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  head: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: "500",
    textAlign: "center",
  },
  limg: {
    width: "159px",
    height: "22px",
  },
  img1: {
    width: "24px",
    height: "24px",
  },
  img2: {
    width: "56px",
    height: "56px",
  },
  text1: {
    textAlign: "center",
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "600",
    color: "black",
    textDecoration: "none",
  },
  text2: {
    textAlign: "center",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  text3: {
    fontFamily: "Saira",
    fontSize: "16px",
  },
  text4: {
    textAlign: "center",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  text5: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#f3901d",
  },
  btn1: {
    width: "100%",
    height: "48px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "white",
    borderRadius: "0px",
  },
};

export default ForgotSuccess;
